import React, {
  ReactElement,
  useRef,
  useState,
  useLayoutEffect,
  useMemo,
  PropsWithChildren,
} from 'react';
import { useOutsideClickListener } from '../../../hooks';
import { PopoverContext, PopoverContextState } from './PopoverContext';
import { Arrow, Card, Container, Content } from './styles';

export const Popover: React.FC<PropsWithChildren<PopoverProps>> = ({
  className,
  actionElement,
  alignment = 'left',
  children,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const [offsetRight, setOffsetRight] = useState(0);
  const [offsetLeft, setOffsetLeft] = useState(0);

  useOutsideClickListener(containerRef, () => setOpen(false));
  useLayoutEffect(() => {
    if (containerRef.current && open) {
      const boundaries = containerRef.current.getBoundingClientRect();
      if (boundaries.x < 0) {
        setOffsetLeft(-boundaries.x);
      }
      if (window.innerWidth < boundaries.x + boundaries.width) {
        setOffsetRight(boundaries.x + boundaries.width - window.innerWidth);
      }
    }
  }, [open]);

  const contextValue = useMemo<PopoverContextState>(
    () => ({
      close: () => setOpen(false),
    }),
    [],
  );

  return (
    <Container className={className}>
      <span onClick={() => setOpen(!open)}>{actionElement}</span>
      {open ? (
        <Card
          containerRef={containerRef}
          offsets={{ left: offsetLeft, right: offsetRight }}
          alignment={alignment}
          className="card"
        >
          <Arrow />
          <Content className="content">
            <PopoverContext.Provider value={contextValue}>
              {children}
            </PopoverContext.Provider>
          </Content>
        </Card>
      ) : null}
    </Container>
  );
};

export interface PopoverProps {
  className?: string;
  actionElement: ReactElement;
  alignment?: 'left' | 'right';
}
